export const SORT_BY_OPTIONS = [
  { value: "DESC", label: "Descendente" },
  { value: "ASC", label: "Ascendente" },
];
